"use client";

import { c as _c } from "react/compiler-runtime";
import CrewHero from "@/components/pages/crew/CrewHero";
import CrewRelatedMovies from "@/components/pages/crew/CrewRelatedMovies";
import { PersonData } from "@/types/person";
interface Props {
  serverData: PersonData;
}
export default function Crew(t0) {
  const $ = _c(10);
  const {
    serverData
  } = t0;
  let t1;
  if ($[0] !== serverData) {
    t1 = <CrewHero profile={serverData} />;
    $[0] = serverData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== serverData.contents || $[3] !== serverData.meta || $[4] !== serverData.name_fa || $[5] !== serverData.uuid) {
    t2 = <div className="px-6 md:px-10"><CrewRelatedMovies title={serverData.name_fa} personUuid={serverData.uuid} movies={serverData.contents} meta={serverData.meta} /></div>;
    $[2] = serverData.contents;
    $[3] = serverData.meta;
    $[4] = serverData.name_fa;
    $[5] = serverData.uuid;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="mx-auto container max-w-3xl overflow-hidden">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}